import { Square, RectangleHorizontal, RectangleVertical } from "lucide-react";
import type { Template, Style, Orientation, ColorOption } from "./types";

export const TEMPLATES: Template[] = [
  { id: "default", name: "Any Design", icon: "✨" },
  { id: "logo", name: "Logo Design", icon: "🏷️" },
  { id: "typography", name: "Typography", icon: "📝" },
  { id: "illustration", name: "Illustration", icon: "🎨" },
  { id: "vintage", name: "Vintage", icon: "📻" },
  { id: "minimalist", name: "Minimalist", icon: "⭕" },
  { id: "band-merch", name: "Band Merch", icon: "🎸" },
  { id: "sports", name: "Sports Team", icon: "⚽" },
  { id: "funny", name: "Funny/Meme", icon: "😄" },
  { id: "abstract", name: "Abstract", icon: "🔶" }
];

export const STYLES: Style[] = [
  { id: "default", name: "Any Style", color: "bg-gray-500" },
  { id: "vector", name: "Vector Art", color: "bg-blue-500" },
  { id: "hand-drawn", name: "Hand Drawn", color: "bg-orange-500" },
  { id: "grunge", name: "Grunge", color: "bg-gray-600" },
  { id: "watercolor", name: "Watercolor", color: "bg-cyan-400" },
  { id: "line-art", name: "Line Art", color: "bg-gray-400" },
  { id: "pop-art", name: "Pop Art", color: "bg-pink-500" },
  { id: "geometric", name: "Geometric", color: "bg-purple-500" },
  { id: "distressed", name: "Distressed", color: "bg-amber-600" },
  { id: "sketch", name: "Sketch", color: "bg-slate-500" }
];

export const ORIENTATIONS: Orientation[] = [
  { id: "square", name: "Square", icon: Square },
  { id: "landscape", name: "Landscape", icon: RectangleHorizontal },
  { id: "portrait", name: "Portrait", icon: RectangleVertical }
];

export const COLOR_OPTIONS: ColorOption[] = [
  { id: "full-color", name: "Full Color" },
  { id: "single-color", name: "Single Color" },
  { id: "two-color", name: "Two Color" },
  { id: "black-white", name: "Black & White" }
];

export const getSizeFromOrientation = (orientation: string): string => {
  if (orientation === "landscape") {
    return "1792x1024";
  }
  if (orientation === "portrait") {
    return "1024x1792";
  }
  return "1024x1024";
};
